"use strict";
exports.__esModule = true;
exports.isFilled = void 0;
var utils_1 = require("../../utils");
var isFilled = function (point) {
    return !utils_1.Objects.isEmpty(point.srs) && !utils_1.Objects.isEmpty(point.x) && !utils_1.Objects.isEmpty(point.y);
};
exports.isFilled = isFilled;
//# sourceMappingURL=isFilled.js.map